export const paths = state => {
    return state.paths;
}


// WEBPACK FOOTER //
// ./src/store/getters.js